import { useNoteImage } from '../hooks/useNoteImage';
import { Skeleton } from '@/components/ui/skeleton';

interface NoteImageProps {
  clientId: number;
  noteId: string;
  imageId: string;
  alt: string;
  thumb?: boolean;
  className?: string;
  onClick?: () => void;
}

export function NoteImage({
  clientId,
  noteId,
  imageId,
  alt,
  thumb = false,
  className = '',
  onClick,
}: NoteImageProps) {
  const { data: src, isLoading, error } = useNoteImage({
    clientId,
    noteId,
    imageId,
    thumb,
  });

  if (isLoading) {
    return <Skeleton className={className} />;
  }

  if (error || !src) {
    return (
      <div className={`${className} bg-muted flex items-center justify-center text-muted-foreground text-xs`}>
        Ошибка
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onClick={onClick}
      loading="lazy"
    />
  );
}
